export default __webpack_public_path__ + "static/media/google.623473aa.svg";